import { Component } from '@angular/core';

@Component({
  selector: 'rid-mechanic-background',
  imports: [],
  templateUrl: './rid-mechanic-background.html',
  host: {
    class: 'contents',
  },
})
export class RidMechanicBackground {}
